import { Anchor } from '@components/atoms/Anchor';
import Section from '@components/atoms/Section';
import Spacing from '@components/atoms/Spacing';
import { Heading2, Paragraph } from '@components/atoms/Typography';
import { CoverageType, QuoteOfferQuery } from '@graphql/generated';
import BREAKPOINTS from '@lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import React from 'react';
import styled from 'styled-components';

const CoverageCardWrapper = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 32px 16px;
  width: 100%;
  border-radius: 4px;

  overflow: hidden;
  border-top: 1px #dadada dashed;

  :nth-of-type(1) {
    border-top: 0;
  }
`;

export const CoveragesGrid = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 32px;
  grid-gap: 0;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;

  @media screen and (min-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: 1fr;
    align-content: space-around;
    justify-content: space-around;
    /* grid-gap: 16px; */

    li {
      background: #ffffff;
      /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25); */

      align-items: flex-start;

      p {
        text-align: left;
      }
    }
  }
`;

export const CoverageCard = ({
  name,
  description,
  label,
}: {
  name: string;
  description: React.ReactNode;
  label: string;
}) => (
  <CoverageCardWrapper>
    <Paragraph center>
      <strong>{name}</strong>
    </Paragraph>
    <Spacing vertical={2}>
      <Paragraph center style={{ fontSize: 14 }}>
        {description}
      </Paragraph>
    </Spacing>
    <Paragraph center style={{ fontSize: 18 }}>
      <strong>{label}</strong>
    </Paragraph>
  </CoverageCardWrapper>
);

export function rewriteCoverages(
  coverages: QuoteOfferQuery['quote']['offer']['coverages'],
  suhaiPartner: boolean
) {
 return coverages
    .map((coverage) => {
      if (coverage.type === CoverageType.Theft && suhaiPartner) {
        return {
          ...coverage,
          description: (
            <>
              Seu veículo foi roubado ou furtado? Você não fica no prejuízo.
              <br />
              <br />A <strong>Suhai</strong> irá garantir que tudo fique bem.
              Você recebe a indenização contratada a apólice se ele não for
              encontrado em até 30 dias ou se ele for encontrado mas com danos
              acima de 75%.
            </>
          ),
        };
      }

      if (coverage.type === CoverageType.TotalLoss && suhaiPartner) {
        return {
          ...coverage,
          description: (
            <>
              <>
                Aconteceu um acidente e não vai ser possível consertar os danos
                do seu veículo?
              </>
              <br />
              <br />A <strong>Suhai</strong> irá te indenizar caso ocorra algum
              dano ao seu veículo causado por colisões, incêndio, explosões
              acidentais, quedas ou outros acidentes de causas externas. O preço
              do conserto precisa ser maior que 75% do valor do veículo de
              acordo com a tabela FIPE no período do acionamento.
            </>
          ),
        };
      }

      return coverage;
    })

    .filter((c) => {
      if (suhaiPartner) {
        return ![CoverageType.Nature, CoverageType.Fire].includes(c.type);
      }
      return true;
    });
}

const CoveragesSection = ({
  coverages,
  suhaiPartner,
}: {
  coverages: QuoteOfferQuery['quote']['offer']['coverages'];
  suhaiPartner: boolean;
}) => (
  <Section style={{ backgroundColor: COLORS.pastel }}>
    <div className="quote-resume-margin">
      <Spacing vertical={2}>
        <Heading2 center>O que está Coberto</Heading2>
      </Spacing>
      <CoveragesGrid>
        {rewriteCoverages(coverages, suhaiPartner).map((coverage) => (
          <CoverageCard
            key={coverage.type}
            name={coverage.name}
            label={coverage.label}
            description={coverage.description}
          />
        ))}
      </CoveragesGrid>

      {suhaiPartner && (
        <Paragraph style={{ marginTop: 32, textAlign: 'center' }}>
          <Anchor
            href="https://suhaiseguradora.com/wp-content/uploads/2022/02/CG-GERAL-AUTO_fevereiro-de-2022_atual_Suhai-Seguradora.pdf"
            target="_blank"
          >
            Consulte informações detalhadas e limites nas Condições Gerais
          </Anchor>
        </Paragraph>
      )}
    </div>
  </Section>
);

export default CoveragesSection;
